export default __webpack_public_path__ + "static/media/README.bb78581c.md";